const HIDDEN_PLACEHOLDER_DESCRIPTIONS = new Set(["default", "defaulf"]);

export function isDefaultLicenseDescription(description) {
  const normalized = String(description ?? "").trim().toLowerCase();
  return HIDDEN_PLACEHOLDER_DESCRIPTIONS.has(normalized);
}

export const LICENSE_KIND_LABELS = {
  free: "Свободная",
  activ: "Активна",
  inactive: "Не активна",
};
